<div *transloco="let t" class="bazis-select-on-map-control">
    <ng-container
        *ngIf="{
            required: required$ | async
        } as data"
    >
        <bazis-toolbar>
            <div
                slot="start"
                *ngIf="canSearch"
            >
                <bazis-input-default
                    [formControl]="search"
                    [placeholderKey]="'form.placeholder.searchOnMap'"
                    [rightIcon]="icons.search"
                    [sizeControl]="sizeControl"
                ></bazis-input-default>
            </div>
            <div
                slot="end"
                *ngIf="canToggleMode"
                class="bh-line-elements"
            >
                <div class="bazis-btn-group">
                    <div class="bazis-btn-group__item">
                        <bazis-button
                            fill="clear"
                            size="compact"
                            [active]="mode === 'map'"
                            (click)="setMode('map')"
                        >
                            <bazis-icon
                                slot="icon-only"
                                [name]="icons.mapMarker"
                            ></bazis-icon>
                        </bazis-button>
                    </div>
                    <div class="bazis-btn-group__item">
                        <bazis-button
                            fill="clear"
                            size="compact"
                            [active]="mode === 'both'"
                            (click)="setMode('both')"
                        >
                            <bazis-icon
                                slot="icon-only"
                                [name]="icons.list"
                            ></bazis-icon>
                        </bazis-button>
                    </div>
                </div>

                <ng-container *ngIf="createButton">
                    <ng-container [ngTemplateOutlet]="createButton"></ng-container>
                </ng-container>
            </div>
        </bazis-toolbar>

        <div
            *ngIf="{
                list: list$ | async,
                selectedId: selectedId$ | async,
                updateAfterSelectedId: updateAfterSelectedId$ | async
            } as data"
        >
            <div *ngIf="mode === 'list' || mode === 'both'">
                <ng-container *ngFor="let item of data.list; let i = index; trackBy: trackById">
                    <div (click)="selectFromList(item.id)">
                        <ng-template
                            [ngTemplateOutlet]="itemTpl"
                            [ngTemplateOutletContext]="{
                                item: item,
                                isSelected: item.id === data.selectedId
                            }"
                        ></ng-template>
                    </div>
                </ng-container>
            </div>
            <div
                class="bazis-map-wrapper"
                *ngIf="mode === 'map' || mode === 'both'"
            >
                <bazis-map
                    [mapSettings$]="mapSettings.$"
                    [mapLayers$]="mapLayers.$"
                    [selectOnMap$]="selectOnMap.$"
                    (popupAction)="processPopupAction($event)"
                ></bazis-map>
            </div>
        </div>

        <ng-container *ngIf="{ searchValue: searchValue$ | async } as data"></ng-container>
    </ng-container>
</div>
